import { BespokeMarketApi } from '../../api'

export default class BespokeMarketManager {
  getAvailableMarkets (eventId, paging, language = 'ENG', signal = null) {
    return BespokeMarketApi.getAvailableMarkets({ eventId, paging, language, signal })
  }
}
